import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@sea-snag/ui';
import * as Sentry from '@sentry/react';
import type { ReactElement, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  fallback?: ReactElement;
}

function DefaultFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>Something went wrong</CardTitle>
          <CardDescription>An unexpected error occurred.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <Button onClick={() => window.location.reload()}>Reload page</Button>
        </CardContent>
      </Card>
    </div>
  );
}

export function ErrorBoundary({ children, fallback }: Props) {
  return (
    <Sentry.ErrorBoundary fallback={fallback ?? <DefaultFallback />}>
      {children}
    </Sentry.ErrorBoundary>
  );
}
